<template>
  <div class="footer">
    <h4>Development by <a target="_blank" href="https://github.com/ajvanegasv">ajvanegasv</a></h4>
    <Github />
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.footer{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #171123;
  height: 4em;
  color: #def;
  flex-direction: row;
}

a{
  color: #5B85AA;
}
</style>